import { createContext } from 'react-router';
import type { InitialData } from '~/lib/getInitialData';

export const rootDataContext = createContext<InitialData | undefined>(
  undefined
);
